import { useHistory } from 'react-router-dom';
import { CommandPaletteAction } from 'components/CommandPaletteDialog/commandPaletteAction.types';
import { useKeyboardShortcuts } from 'hooks/useKeyboardShortcuts/useKeyboardShortcuts';
import { HeaderMenuAction } from '../../components/PageLayout/HeaderBar/types';

export const useHeaderActionCommandPaletteActions = (
  menuActions: HeaderMenuAction[],
): void => {
  const history = useHistory();
  const shortcuts: CommandPaletteAction[] = menuActions
    .filter((action) => !action.disabled)
    .map((action) => ({
      category: 'common',
      description: action.label,
      keys: action.keyboardShortcut,
      handler: () => history.push(action.to),
    }));

  useKeyboardShortcuts(shortcuts, [menuActions]);
};
